// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isPostIntegrationsDirectCdiCatalogSchemaDiffResult = objectOf({
  existing_fields: arrayOf(
    objectOf({
      name: string,
      type: string,
    })
  ),
  new_fields: arrayOf(
    objectOf({
      name: string,
      type: string,
    })
  ),
});
